const PendingStaffIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clipPath="url(#clip0_590_7318)">
        <mask
          id="mask0_590_7318"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="48"
        >
          <path d="M48 0H0V48H48V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_590_7318)">
          <path
            d="M39 48H9C4.02905 48 0 43.9709 0 39V9C0 4.02905 4.02905 0 9 0H39C43.9709 0 48 4.02905 48 9V39C48 43.9709 43.9709 48 39 48Z"
            fill="#FFFAEA"
          />
          <path
            d="M25.9995 16.9995C25.9995 19.7607 23.7612 21.999 21 21.999C18.2388 21.999 16.0005 19.7607 16.0005 16.9995C16.0005 14.2383 18.2388 12 21 12C23.7612 12 25.9995 14.2383 25.9995 16.9995Z"
            fill="#FDCE2F"
          />
          <path
            d="M21.4995 29.5005C21.4995 27.3706 22.3425 25.4355 23.7045 24H16.749C14.1313 24 12 26.1313 12 28.7505V32.25C12 32.6638 12.3362 33 12.75 33H22.3169C21.7994 31.9409 21.4995 30.7559 21.4995 29.5005Z"
            fill="#FDCE2F"
          />
          <path
            d="M29.5005 22.999C25.9171 22.999 23.001 25.9152 23.001 29.4985C23.001 33.0819 25.9156 35.9995 29.5005 35.9995C33.0853 35.9995 36 33.0834 36 29.5C36 25.9166 33.0839 22.999 29.5005 22.999ZM31.7069 31.7064C31.5121 31.9016 31.2554 31.999 31.0005 31.999C30.7441 31.999 30.4889 31.9016 30.2941 31.7064L28.7941 30.2064C28.6051 30.0189 28.5 29.7655 28.5 29.5V26.9995C28.5 26.4476 28.9486 25.999 29.5005 25.999C30.0524 25.999 30.501 26.4462 30.501 26.9995V29.0862L31.7084 30.2936C32.0969 30.6836 32.0969 31.3164 31.7069 31.7064Z"
            fill="#FFE777"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_590_7318">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default PendingStaffIcon;
